"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const counterDefaultValues = {
  title: "Coming Soon",
  description:
    "Experience the reveal. Introducing a brave new step forward for Heated Tobacco pleasure. Welcome to the next generation. Welcome to Ploom X.",
  desktopBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F33103852e7784bd4a30d796bec82f6ee",
    alt: "desktop background image",
    title: "desktop title",
  },
  tabletBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F33103852e7784bd4a30d796bec82f6ee",
    alt: "medium background image",
    title: "medium title",
  },
  mobileBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F33103852e7784bd4a30d796bec82f6ee",
    alt: "mobile background image",
    title: "mobile title",
  },
  date: "2025-11-01T00:00:00.000Z",
};

export const counterInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: counterDefaultValues.title,
  },
  {
    name: "description",
    type: "richText",
    defaultValue: counterDefaultValues.description,
  },
  {
    name: "date",
    type: "date",
    required: true,
    defaultValue: counterDefaultValues.date,
  },
  {
    name: "desktopBackgroundImage",
    type: "object",
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: counterDefaultValues.desktopBackgroundImage,
  },
  {
    name: "tabletBackgroundImage",
    type: "object",
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: counterDefaultValues.tabletBackgroundImage,
  },
  {
    name: "mobileBackgroundImage",
    type: "object",
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: counterDefaultValues.mobileBackgroundImage,
  },
] as const satisfies Inputs;

export const CounterComponent: RegisteredComponent = {
  name: "Counter",
  component: dynamic(async () =>
    withValidation(
      counterInputs,
      (await import("./Counter")).Counter,
      "Counter"
    )
  ),
  inputs: counterInputs,
};
